import React, { Component } from 'react'; // Import Component
import PropTypes from 'prop-types';
import { CardContainer, CardTitle, CardTotal } from './styled';
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent"; // Import styled components

// React Component (Class-based)
class TotalizeTableCompaignMetaComponent extends Component {
    render() {
        const { title, total } = this.props; // Destructure props inside render

        return (
            <CardContainer>
                <CardTotal>{total}</CardTotal>
                <CardTitle>{title}</CardTitle>
            </CardContainer>
        );
    }
}

// PropTypes
TotalizeTableCompaignMetaComponent.propTypes = {
    title: PropTypes.string.isRequired,
    total: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
};

export default TotalizeTableCompaignMetaComponent;